import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cf0d8c14"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cards"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "核心业务", -1));
const _hoisted_4 = {
  class: "card-list"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "text-container"
};
const _hoisted_7 = {
  class: "desc"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-button-container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "card-button",
  onclick: "if(mini_dialog.windowstate==1){ mini_dialog.maxwindow()}"
}, "在线咨询")], -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'cards',
  setup(__props) {
    const cardData = [{
      title: '物联网开发',
      desc: '支持智慧农业物联网平台/智慧牧业物联网平台/灾害监测预警系统/智慧景区管理系统/车辆管理系统/智慧渔业管理平台等物联网软件的开发，提供一站式物联网平台开发部署服务，源代码交付。',
      iconUrl: require('@/assets/service/icon-1.png')
    }, {
      title: '小程序开发',
      desc: '按需定制开发H5页面/微信/公众号/服务/小程序等多种类型微信端应用，源代码交付。',
      iconUrl: require('@/assets/service/icon-2.png')
    }, {
      title: '网站开发',
      desc: '专业提供卫星过境监测/企业门户网站/校园门户网站/项目成果展示网站，致力为企业提供优质的售前和售后服务，源代码交付。',
      iconUrl: require('@/assets/service/icon-3.png')
    }, {
      title: '智慧大屏',
      desc: '基于物联网/工业物联网业务场景，对接各种数据源，以图形化形式展示数据，支持实时数据，历史数据和统计数据展示，支持私有化部署，源代码交付。',
      iconUrl: require('@/assets/service/icon-4.png')
    }];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cardData, item => {
        return _createElementVNode("div", {
          class: "card",
          key: item.title
        }, [_createElementVNode("img", {
          class: "icon",
          src: item.iconUrl,
          alt: ""
        }, null, 8, _hoisted_5), _createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(item.desc), 1)]), _hoisted_8]);
      }), 64))])])]);
    };
  }
});